module.exports = __webpack_public_path__ + "static/bearmaps-d051d2a4a47647444ecf4e10e5dc5ee9.png";